<template>
  <div :class="{ 'campaign-loading': isLoading }">
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div class="row">
      <div class="text-right align-self-end">
        <button
          class="btn btn-outline-primary"
          @click="() => $router.push({ name: 'DetailTopSpenderCampaign' })"
        >
          Create
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
      <div class="col-3">
        <label for="statusSelected">Status</label>
        <multiselect
          id="statusSelected"
          v-model="statusSelected"
          :options="statusOptions"
          label="text"
          track-by="text"
        >
        </multiselect>
      </div>
      <div class="col-3">
        <label for="searchKeyword">Name</label>
        <input
          id="searchKeyword"
          type="text"
          class="form-control py-2"
          v-model="searchKeyword"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div class="p-2 align-self-center">
        <button class="btn btn-outline-secondary" @click="resetFilter">
          Reset
        </button>
      </div>
      <div class="p-2 align-self-center">
        <button class="btn btn-outline-primary" @click="searchCampaign">
          Search
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listCampaigns"
        :per-page="perPage"
        @sort-changed="sortCompare"
        show-empty
      >
        <template #empty>
          <h1 class="text-center m-5">ไม่มีข้อมูลที่แสดง</h1>
        </template>
        <template #cell(nameTh)="data">
          <div>
            {{ data.item.nameTh }} <br />
            {{ data.item.nameEn }}
          </div>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailTopSpenderCampaign',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
import fields from "@/views/TopSpenderCampaign/listTopSpenderFields.json";
import TopSpenderCampaignService from "services/api/topSpenderCampaign.service";
import moment from "moment/moment";

export default {
  components: {
    BrandDropdown,
  },

  data() {
    return {
      ...DefaultListViewData,
      searchKeyword: null,
      statusSelected: null,
      statusOptions: [{ text: "Active" }, { text: "Inactive" }],
      isLoading: true,
      listCampaigns: [],
      fields,
    };
  },
  mounted() {
    this.getCampaigns();
  },
  methods: {
    async getCampaigns() {
      const params = {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        key: this.searchKeyword,
        status: this.statusSelected
          ? this.statusSelected.text?.toUpperCase()
          : null,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: this.sort.key || "id",
        sortType: this.sort.type === "asc" ? "asc" : "desc",
      };

      await TopSpenderCampaignService.getListTopSpenderCampaign(params)
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItem;
          this.listCampaigns = data.topSpenderCampaigns.map((t) => {
            return {
              ...t,
              status: t.status === "ACTIVE" ? "Active" : "Inactive",
              startDate: moment(t.startDate).format("YYYY-MM-DD"),
              endDate: moment(t.endDate).format("YYYY-MM-DD"),
            };
          });

          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    changePage() {
      this.getCampaigns();
    },
    onChangeEntries() {
      this.getCampaigns();
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getCampaigns();
    },
    setBrand(brand) {
      this.brandSelected = brand || null;
    },
    searchCampaign() {
      this.isLoading = true;
      this.getCampaigns();
    },
    resetFilter() {
      this.brandSelected = null;
      this.searchKeyword = null;
      this.statusSelected = null;
      this.getCampaigns();
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.campaign-loading > :not(:first-child) {
  pointer-events: none;
  opacity: 0.4;
}
</style>
